export class ContractDetails {
  contractNo: number;
  isRental: boolean;
  siteEnabled: boolean;
  siteLicences: number;
  activations: Usage;
  vmActivations: Usage;
  dtActivations: Usage;
  cloneTokens: Usage;
  syncTokens: Usage;
  asrTokens: Usage;
  hostTokens: Usage;
  upgradeTokens: Usage;
  stagingTokens: Usage;
  raTokens: Usage;
  raBulkTokens: Usage;
  capacity: Usage;
  totalCapacityTB: number;
  serverLics: number;
  virtualPacks: number;
  dtLics: number;
  product: string;
  comment: string;
  maintStartDate: string;
  maintEndDate: string;
}

export class Usage {
  total: number;
  available: number;
}
